export const dataTxHistory = [
  {
    TxID: "0x7c22341257849541e56501",
    date: "14 secs ago",
    type: "$BEET Transfer",
    comment: "From 0x690B9A...b4FaC990 To 0xeBec79...F299cAcf",
  },
  {
    TxID: "0x1237c57849541e56501",
    date: "15 secs ago",
    type: "Delegate / Stake",
    comment: "BEET will be available on December 1st",
  },
  {
    TxID: "0x767435c57849541e56501",
    date: "14 secs ago",
    type: "$BEET Transfer",
    comment: "Amount Delegated : 3520",
  },
  {
    TxID: "0x57ae7c57849541e56501",
    date: "38 secs ago",
    type: "$BEET Buy",
    comment: "Amount Purchased : 435",
  },
  {
    TxID: "0x1722c57849541e56501",
    date: "Nov 15th 1pm:28",
    type: "Redelgate",
    comment: "From 0x690B9A...b4FaC990 To 0xeBec79...F299cAcf",
  },
  {
    TxID: "0x4447c57849541e56501",
    date: "Nov 15th 3pm:28",
    type: "BEET NFT buy",
    comment: "NFT price : 23 usd",
  },
];
